// @flow

import {
  ADD_UNSAVED_WORK,
  MARK_WORK_SAVED,
  CLEAR_UNSAVED_WORK
} from '../actions/unsavedwork'

const initialState : {
  items: Array<Object>
} = {
  items: []
}

export function unsavedwork (state: Object = initialState, action: Object) : Object {
  switch (action.type) {
    case ADD_UNSAVED_WORK:
      if (state.items.map(w => w.id).includes(action.payload.id)) {
        return state
      } else {
        return {
          items: [
            ...state.items,
            {
              id: action.payload.id,
              safePath: action.payload.safePath,
              modal: action.payload.modal
            }
          ]
        }
      }
    
    case MARK_WORK_SAVED:
      return {
        items: state.items.filter(w => w.id !== action.payload.id)
      }

    case CLEAR_UNSAVED_WORK:
      return initialState

    default:
      return state
  }
}
